import RaikoSimpleInputOutlined from "../../raikoComponents/raikoCustomInput/RaikoSimpleInputOutlined";
import React, {useEffect, useState} from "react";
import {css} from "@emotion/css";
import RaikoMobileInputOutlined from "../../raikoComponents/raikoCustomInput/RaikoMobileInputOutlined";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {LoadingHelper} from "../../util/LoadingHelper";
import {ManagerService} from "../../serverService/managerManagement/ManagerService";
import RaikoGridTwoColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridTwoColumn";
import ButtonDivisionSection from "../../component/ButtonDivisionSection/ButtonDivisionSection";
import {RaikoAlert, raikoAlertTypes} from "../../raikoComponents/raikoAlert/RaikoAlert";

const ManagerAddNew = ({changeNeedRefresh}) => {
    let page = 0
    const size = 15

    const serviceManager = new ManagerService()

    const snackbarDispatch = useSnackbarDispatcher();
    const snackbar = new SnackbarHelper(snackbarDispatch)

    const loadingDispatcher = useLoadingDispatcher()
    const loading = new LoadingHelper(loadingDispatcher)

    /* useEffect(() => {
         if (serviceManagerAccessLevel) {
             getManagerAccessLevels()
         }
     }, [])*/

    /* function getManagerAccessLevels() {

         serviceManagerAccessLevel.getAccessLevelList(page, size)
             .then(response => {
                 setPageCount(response.totalPage)

                 setAccessLevel([])
                 response.data.map((item, index) => {
                     setAccessLevel(prevState => [
                         ...prevState,
                         prepareManagerAccessLevelTableRow(item.id, page * size + index + 1, item.name, item.name)
                     ])
                 })
             }).catch(reason => {

             snackbar.showErrorMessage(
                 new ServerErrorHandler(reason).getMessage("خطا در دریافت اطلاعات")
             )
         })
     }*/


    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("")
    const [nationalCode, setNationalCode] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")
    const [userName, setUserName] = useState("")
    const [password, setPassword] = useState("")
    const [status, setStatus] = useState(true)

    /*const [accessLevel, setAccessLevel] = useState([])
    const [selectedAccessLevels, setSelectedAccessLevels] = useState([]);
    const [pageCount, setPageCount] = useState(2);
*/

    function handleChangePagination(newPage) {
        page = newPage
    }

    function handleChange() {
        loading.show()
        serviceManager.addNewManager(firstName, lastName, phoneNumber, userName, password)
            .then(response => {
                changeNeedRefresh(true)
                clearFields()
                snackbar.showSuccessMessage("مدیر جدید با موفقیت افزوده شد.")
                loading.hide()
            }).catch(reason => {
            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage())
            loading.hide()
        })
    }

    function clearFields() {
        setFirstName("")
        setLastName("")
        setPhoneNumber("")
        setUserName("")
        setPhoneNumber("")
        setPassword("")
        // setSelectedAccessLevels([])
    }

    return (
        <>
            <RaikoGridOneColumn
                className={css`padding: 0 1rem 1rem 1rem;`}>
                <RaikoAlert
                    type={raikoAlertTypes.warning}
                    title={"سطح دسترسی"}
                    description={[
                        "* لطفا بعد از ساخت مدیر جدید با مراجعه به جزئيات مدیر، سطح دسترسی مورد نظر را برای مدیر انتخاب نمایید."
                    ]}
                />

                <RaikoGridTwoColumn>
                    <RaikoSimpleInputOutlined
                        value={firstName}
                        setValue={setFirstName}
                        labelText={"نام"}
                    />
                    <RaikoSimpleInputOutlined
                        value={lastName}
                        setValue={setLastName}
                        labelText={"نام خانوادگی"}
                    />
                    <RaikoMobileInputOutlined
                        value={phoneNumber}
                        setValue={setPhoneNumber}
                        labelText={"شماره همراه"}
                    />
                    <RaikoSimpleInputOutlined
                        value={userName}
                        setValue={setUserName}
                        labelText={"نام کاربری"}
                    />
                    <RaikoSimpleInputOutlined
                        value={password}
                        setValue={setPassword}
                        labelText={"رمز عبور"}
                    />
                </RaikoGridTwoColumn>

                <ButtonDivisionSection>
                    <ButtonPrimaryRaiko label={"افزودن مدیر"} onClick={handleChange}/>
                </ButtonDivisionSection>

            </RaikoGridOneColumn>


        </>

    )
}
export default ManagerAddNew

